import { CanDeactivate} from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

export interface CanComponentDeactivate {
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable({
  providedIn: 'root'
})
export class CanDeactivateGuard implements CanDeactivate<CanComponentDeactivate> {
  private confirmationDisplayed = false;

  constructor() {}

  canDeactivate(component: CanComponentDeactivate,
    ): Observable<boolean> | Promise<boolean> | boolean {

    if (this.confirmationDisplayed) {
      this.confirmationDisplayed = false;
      return component.canDeactivate();
    }

    this.confirmationDisplayed = true;
    return component.canDeactivate();

  }


  displayConfirmation(): void {
    this.confirmationDisplayed = true;
  }
}




